import { UserInterface, LoginDepartmentInterface } from "./Interfaces";

export class UserHelper {
  static currentDepartment: LoginDepartmentInterface;
  static departments: LoginDepartmentInterface[];
  static user: UserInterface;
  static departmentChanged: boolean = false;

  static checkAccess = (permission: string) => {
    let result = false;
    UserHelper.currentDepartment.permissions.forEach(p => { if (p === permission) result = true });
    return result;
  }

}